import { Component } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { RouterHistoryService, WindowService } from '../../services/router-history';

@Component({
  selector: 'back-button',
  template: `
  <button mat-button class="btn-ghost-secondary hovered  btn-hover color-11"
    style="vertical-align: middle; color: darkgrey"
    [routerLink]="previousUrlViaRoutesRecognized$ | async"
    (click)="onClick($event)"><mat-icon style="vertical-align: middle;">arrow_back</mat-icon>
  </button>
  `,
  styles: [`
  .btn-ghost-secondary,
.hovered {
  color: white !important;
}

.btn-hover {
  background-size: 300% 100%;
  // border-radius: 50px;
  moz-transition: all .4s ease-in-out;
  -o-transition: all .4s ease-in-out;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
}

.btn-hover:hover {
  background-position: 100% 0;
  moz-transition: all .4s ease-in-out;
  -o-transition: all .4s ease-in-out;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
}

.btn-hover:focus {
  outline: none;
}

.btn-hover.color-11 {
  background-image: linear-gradient(to right, #0f9af7, #3dacf8, #57bcf7, #0e99f7);
  box-shadow: 2px 2px 7px rgb(154 154 154 / 40%);
}
  `]
})

// <button type="button" class="btn-info"[routerLink] = "previousUrlViaRouterHistoryService$ | async"
//   (click) = "onClick($event)" > <mat-icon > arrow_back < /mat-icon>
//   < /button>

// <button
//     mat - raised - button
// style = "margin-right: 8px;"
// color = "primary"
// [routerLink] = "previousUrlViaRouterHistoryService$ | async"
//   (click) = "onClick($event)"
// matTooltip = "Go back"
// matTooltipHideDelay = "500"
// matTooltipPosition = "above"
// matTooltipClass = "custom-tooltip" >
//   <mat-icon > arrow_back < /mat-icon>
//   < /button>
export class BackButtonComponent {

  public previousUrlViaRoutesRecognized$ = new BehaviorSubject<string>(null);
  public currentUrlViaRoutesRecognized$ = new BehaviorSubject<string>(null);

  constructor(
    private router: Router,
    private routerHistoryService: RouterHistoryService,
    private windowService: WindowService
  ) {
    // Via RoutesRecognized
    router.events
      .pipe(
        filter(evt => evt instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe(
        ([previous, current]: [RoutesRecognized, RoutesRecognized]) => {
          this.previousUrlViaRoutesRecognized$.next(previous.urlAfterRedirects);
          this.currentUrlViaRoutesRecognized$.next(current.urlAfterRedirects);
        }
      );
  }

  onClick($event: MouseEvent): void {
    $event.preventDefault();
    this.windowService.nativeWindow.history.back();
  }
}
